import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uk-card-small uk-card-default uk-margin-small-top" }
const _hoisted_2 = { class: "uk-card-body" }
const _hoisted_3 = { class: "uk-grid uk-grid-divider" }
const _hoisted_4 = {
  key: 0,
  class: "uk-width-1-3"
}
const _hoisted_5 = { class: "uk-margin uk-flex-inline uk-child-width-auto uk-grid" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "uk-margin-remove-bottom uk-margin-small-top" }
const _hoisted_8 = { class: "uk-margin-remove-top" }
const _hoisted_9 = {
  key: 0,
  class: "uk-margin-remove-bottom"
}
const _hoisted_10 = {
  key: 1,
  class: "uk-margin-remove-bottom"
}
const _hoisted_11 = { class: "uk-margin uk-flex-inline uk-child-width-auto uk-grid" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 4,
  class: "uk-grid uk-margin-remove-top"
}
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { class: "uk-margin-remove-bottom uk-margin-small-top" }
const _hoisted_18 = { class: "uk-margin-remove-top" }
const _hoisted_19 = {
  key: 6,
  class: "uk-grid uk-margin-remove-top"
}
const _hoisted_20 = {
  key: 7,
  class: "uk-grid uk-margin-remove-top"
}
const _hoisted_21 = {
  key: 8,
  class: "uk-flex"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 2,
  class: "uk-grid uk-margin-remove-top"
}
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "uk-margin-remove-bottom uk-margin-small-top" }
const _hoisted_26 = { class: "uk-margin-remove-top" }
const _hoisted_27 = {
  key: 4,
  class: "uk-grid uk-margin-remove-top"
}
const _hoisted_28 = {
  key: 5,
  class: "uk-grid uk-margin-remove-top"
}
const _hoisted_29 = {
  key: 6,
  class: "uk-flex"
}
const _hoisted_30 = {
  key: 0,
  class: "uk-card-small uk-card-default uk-margin-small-top"
}
const _hoisted_31 = { class: "uk-card-body" }
const _hoisted_32 = { class: "uk-grid uk-grid-divider" }
const _hoisted_33 = { class: "uk-width-1-3" }
const _hoisted_34 = { class: "uk-margin uk-flex-inline uk-child-width-auto uk-grid" }
const _hoisted_35 = { class: "uk-width-1-3" }
const _hoisted_36 = { class: "uk-margin uk-flex-inline uk-child-width-auto uk-grid" }
const _hoisted_37 = { class: "uk-width-1-3" }
const _hoisted_38 = { class: "uk-margin uk-flex-inline uk-child-width-auto uk-grid" }
const _hoisted_39 = {
  key: 1,
  class: "uk-card-small uk-card-default uk-margin-small-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddNewOrderFormReferenceArea = _resolveComponent("AddNewOrderFormReferenceArea")!
  const _component_FilterSelector = _resolveComponent("FilterSelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_ship_line_card = _resolveComponent("ship-line-card")!
  const _component_AddContainersArea = _resolveComponent("AddContainersArea")!
  const _component_AddLoadsArea = _resolveComponent("AddLoadsArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AddNewOrderFormReferenceArea, {
      settingsOrderShowLinkedOrderNumberField: _ctx.settingsOrderShowLinkedOrderNumberField,
      isOceanExport: _ctx.isOceanExport,
      isOceanImport: _ctx.isOceanImport,
      isLand: _ctx.isLandOrder,
      orderData: _ctx.orderData,
      showBrokerFields: _ctx.showBrokerFields,
      mappedBLs: _ctx.mappedBLs,
      isRailPickUp: _ctx.isRailPickUp,
      isRailDropOff: _ctx.isRailDropOff,
      activeBLs: _ctx.activeBLs
    }, null, 8, ["settingsOrderShowLinkedOrderNumberField", "isOceanExport", "isOceanImport", "isLand", "orderData", "showBrokerFields", "mappedBLs", "isRailPickUp", "isRailDropOff", "activeBLs"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.isAddingNewDropoff & !_ctx.isAddingNewBillTo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.isLandOrder)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[23] || (_cache[23] = _createElementVNode("p", { class: "uk-margin-remove-bottom" }, " Pick-Up Location (*required) ", -1)),
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.terminals)
                          ? (_openBlock(), _createBlock(_component_FilterSelector, {
                              key: 0,
                              "preserve-search": true,
                              showLabels: false,
                              placeholder: "Location",
                              modelValue: _ctx.orderData.pickUpLocation,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderData.pickUpLocation) = $event)),
                              customLabel: (x) => (x.shortName ? x.shortName : x.name),
                              options: _ctx.receivingCustomers,
                              class: "uk-width-medium",
                              onSearchChange: _ctx.onReceivingCustomerSearch
                            }, null, 8, ["modelValue", "customLabel", "options", "onSearchChange"]))
                          : _createCommentVNode("", true),
                        (
                    _ctx.orderData.pickUpLocation &&
                    _ctx.orderData.pickUpLocation.deliveryAddress
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.orderData.pickUpLocation.deliveryAddress.streetAddress), 1),
                              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.addressLine3(_ctx.orderData.pickUpLocation.deliveryAddress)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.isOceanExport)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Drop-Off Terminal (*required) "))
                        : (_openBlock(), _createElementBlock("p", _hoisted_10, " Pick-Up Terminal (*required) ")),
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.terminals)
                          ? (_openBlock(), _createBlock(_component_FilterSelector, {
                              key: 0,
                              showLabels: false,
                              placeholder: "Terminal",
                              modelValue: _ctx.orderData.pickUpLocation,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderData.pickUpLocation) = $event)),
                              customLabel: (x) => (x.shortName ? x.shortName : x.name),
                              options: _ctx.terminals,
                              class: "uk-width-medium"
                            }, null, 8, ["modelValue", "customLabel", "options"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isAddingNewBillTo)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass({
              'uk-width-1-3': !_ctx.isAddingNewDropoff,
              'uk-width-1-1': _ctx.isAddingNewDropoff,
            })
              }, [
                (_ctx.isOceanExport)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Pick-up location"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, "Drop-Off Location (*required)")),
                (
                !_ctx.orderData.dropOffLocation &&
                _ctx.receivingCustomers &&
                _ctx.receivingCustomers.length == 0 &&
                !_ctx.isAddingNewDropoff
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.receivingCustomerQuery.length > 0)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            onClick: _ctx.createReceiver,
                            class: "uk-margin-small-bottom"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Create receiver " + _toDisplayString(_ctx.receivingCustomerQuery), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.receivingCustomers && !_ctx.isAddingNewDropoff)
                  ? (_openBlock(), _createBlock(_component_FilterSelector, {
                      key: 3,
                      "preserve-search": true,
                      showLabels: false,
                      placeholder: "Terminal",
                      modelValue: _ctx.orderData.dropOffLocation,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderData.dropOffLocation) = $event)),
                      customLabel: (x) => (x.displayName ? x.displayName : x.name),
                      options: _ctx.receivingCustomers,
                      class: "uk-width-medium",
                      onSearchChange: _ctx.onReceivingCustomerSearch
                    }, {
                      noResult: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("p", null, "No receiver found, please consider creating one", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "customLabel", "options", "onSearchChange"]))
                  : _createCommentVNode("", true),
                (_ctx.isAddingNewDropoff)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_InputField, {
                        id: "streetAddReceiving",
                        label: "Street Address",
                        class: "uk-width-2-3",
                        modelValue: _ctx.newDropoff.streetAddress,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newDropoff.streetAddress) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "suitNumberReceiving",
                        label: "Suite #",
                        modelValue: _ctx.newDropoff.suite,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newDropoff.suite) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : (
                _ctx.orderData.dropOffLocation &&
                _ctx.orderData.dropOffLocation.deliveryAddress
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.orderData.dropOffLocation.deliveryAddress.streetAddress), 1),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.addressLine3(_ctx.orderData.dropOffLocation.deliveryAddress)), 1)
                      ]))
                    : _createCommentVNode("", true),
                (_ctx.isAddingNewDropoff)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "cityReceiving",
                        label: "City",
                        modelValue: _ctx.newDropoff.city,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newDropoff.city) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "stateReceiving",
                        label: "State",
                        modelValue: _ctx.newDropoff.state,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newDropoff.state) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "zipReceiving",
                        label: "Zip",
                        modelValue: _ctx.newDropoff.zipCode,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newDropoff.zipCode) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAddingNewDropoff)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "contactEmail",
                        label: "Email",
                        modelValue: _ctx.newContact.email,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newContact.email) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "Name",
                        label: "Name",
                        modelValue: _ctx.newContact.name,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newContact.name) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "zipReceiving",
                        label: "Phone Number",
                        modelValue: _ctx.newContact.phoneNumber,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newContact.phoneNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAddingNewDropoff)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_Button, {
                        onClick: _ctx.confirmReceiverAddition,
                        class: "uk-width-3-5 uk-margin-small-top"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Save receiver " + _toDisplayString(_ctx.receivingCustomerQuery), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        isGray: true,
                        onClick: _ctx.cancelReceiverCreate,
                        class: "uk-margin-small-left uk-margin-small-top uk-width-2-5"
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode(" Cancel ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.isAddingNewDropoff)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass({
              'uk-width-1-3': !_ctx.isAddingNewBillTo,
              'uk-width-1-1': _ctx.isAddingNewBillTo,
            })
              }, [
                _cache[27] || (_cache[27] = _createElementVNode("p", null, "Bill To (*required)", -1)),
                (
                !_ctx.orderData.billTo &&
                _ctx.billingCustomers &&
                _ctx.billingCustomers.length == 0 &&
                !_ctx.isAddingNewBillTo
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_ctx.billingCustomerQuery.length > 0)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            onClick: _ctx.createBillTo,
                            class: "uk-margin-small-bottom"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Create customer " + _toDisplayString(_ctx.billingCustomerQuery), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.billingCustomers && !_ctx.isAddingNewBillTo)
                  ? (_openBlock(), _createBlock(_component_FilterSelector, {
                      key: 1,
                      "preserve-search": true,
                      showLabels: false,
                      placeholder: "Billng Customer",
                      modelValue: _ctx.orderData.billTo,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.orderData.billTo) = $event)),
                      customLabel: (x) => (x.displayName ? x.displayName : x.name),
                      options: _ctx.billingCustomers,
                      class: "uk-width-medium",
                      onSearchChange: _ctx.onBillingCustomerSearch
                    }, null, 8, ["modelValue", "customLabel", "options", "onSearchChange"]))
                  : _createCommentVNode("", true),
                (_ctx.isAddingNewBillTo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_InputField, {
                        class: "uk-width-2-3",
                        id: "streetAddBillTo",
                        label: "Street Address",
                        modelValue: _ctx.newBillTo.streetAddress,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newBillTo.streetAddress) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "suitNumber",
                        label: "Suite #",
                        modelValue: _ctx.newBillTo.suite,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newBillTo.suite) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_ctx.orderData.billTo && _ctx.orderData.billTo.billingAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.orderData.billTo.billingAddress.streetAddress), 1),
                        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.addressLine3(_ctx.orderData.billTo.billingAddress)), 1)
                      ]))
                    : _createCommentVNode("", true),
                (_ctx.isAddingNewBillTo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "city",
                        label: "City",
                        modelValue: _ctx.newBillTo.city,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newBillTo.city) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "state",
                        label: "State",
                        modelValue: _ctx.newBillTo.state,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newBillTo.state) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "zip",
                        label: "Zip",
                        modelValue: _ctx.newBillTo.zipCode,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newBillTo.zipCode) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAddingNewBillTo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "contactEmail",
                        label: "Email",
                        modelValue: _ctx.newContact.email,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newContact.email) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "Name",
                        label: "Name",
                        modelValue: _ctx.newContact.name,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newContact.name) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputField, {
                        class: "uk-width-1-3",
                        id: "zipReceiving",
                        label: "Phone Number",
                        modelValue: _ctx.newContact.phoneNumber,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newContact.phoneNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAddingNewBillTo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_Button, {
                        onClick: _ctx.confirmBillToAddition,
                        class: "uk-width-3-5 uk-margin-small-top"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Save customer " + _toDisplayString(_ctx.billingCustomerQuery), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        isGray: true,
                        onClick: _ctx.cancelBillToCreate,
                        class: "uk-margin-small-left uk-margin-small-top uk-width-2-5"
                      }, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode(" Cancel ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.settingsOrderShowEmergencyInformation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_InputField, {
                    class: "",
                    id: "orderCarrierName",
                    label: "Carrier Name",
                    modelValue: _ctx.orderData.carrierName,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.orderData.carrierName) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_InputField, {
                    class: "",
                    id: "scacCode",
                    label: "SCAC",
                    modelValue: _ctx.orderData.scacCode,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orderData.scacCode) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_InputField, {
                    class: "",
                    id: "EmergencyPhoneNumber",
                    label: "Emergency Response Phone Number",
                    modelValue: _ctx.orderData.emergencyResponsePhoneNumber,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orderData.emergencyResponsePhoneNumber) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowShipLineInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createVNode(_component_ship_line_card, {
            showBrokerFields: _ctx.showBrokerFields,
            orderData: _ctx.orderData
          }, null, 8, ["showBrokerFields", "orderData"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLandOrder)
      ? (_openBlock(), _createBlock(_component_AddContainersArea, {
          key: 2,
          activeContainersWithoutOrder: _ctx.activeContainersWithoutOrder,
          orderData: _ctx.orderData,
          isOceanExport: _ctx.isOceanExport,
          isOceanImport: _ctx.isOceanImport,
          isLand: _ctx.isLandOrder,
          isRailPickUp: _ctx.isRailPickUp,
          isRailDropOff: _ctx.isRailDropOff,
          settingsOrderLtlEnabled: _ctx.settingsOrderLtlEnabled
        }, null, 8, ["activeContainersWithoutOrder", "orderData", "isOceanExport", "isOceanImport", "isLand", "isRailPickUp", "isRailDropOff", "settingsOrderLtlEnabled"]))
      : (_openBlock(), _createBlock(_component_AddLoadsArea, {
          key: 3,
          orderData: _ctx.orderData
        }, null, 8, ["orderData"]))
  ]))
}